const mutations = {
  setModels(state, data) {
    state.alumnoCursados = data.items;
    // data._meta.totalCount = +data._meta.totalCount+0;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.alumnoCursado = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.alumnoCursados.unshift(model);
  },

  updateModel(state, model) {
    const index = state.alumnoCursados
      .map(function (item) {
        return item.id;
      })
      .indexOf(model.id);
    state.alumnoCursados.splice(index, 1, model);
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.alumnoCursados
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.alumnoCursados.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
